import React from 'react'
import './Loader.css'
import { MagicSpinner } from 'react-spinners-kit'

const Loader = () => {
  return (
    <div className='loader'>

            <div className='loading-content'>

                <MagicSpinner color='#232323'/>

                <div className='loading-message mt-3 white'><h4 >Please Wait</h4></div>

            </div>
               
    </div>  
  )
}

export default Loader
